import { Collection } from 'modules/core/lib/mobx-rest'

import SupplementObservation from 'modules/payroll_bundle/store/models/SupplementObservation'

class SupplementObservations extends Collection<SupplementObservation> {
  get cacheKey(): string {
    return 'supplementObservations'
  }

  model() {
    return SupplementObservation
  }
}

const singleton: SupplementObservations = new SupplementObservations()

export { SupplementObservations }

export default singleton
